module.exports = __webpack_public_path__ + "static/media/newUser.7a18434a.svg";